import React, {createContext, useCallback, useContext, useMemo, useState} from "react";

const BusyContext = createContext();


export function BusyProvider(props) {
    const [busy, setBusy] = useState(false);

    const setIsBusy = useCallback((s) => setBusy(s), []);
    const api = useMemo(() => ({
            busy,
            setIsBusy
        }), [busy,setIsBusy]
    );
    return (<BusyContext.Provider value={api}>
        {props.children}
    </BusyContext.Provider>)
}

export const useBusyContext = () => useContext(BusyContext);
